// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ArrowLeft test Match con el snapshot 1`] = `
<div class="atras"><img src="@/assets/img/1x/Arrow-Left.png" alt="volver">
    <p>Volver</p>
</div>
`;
